import { c as _c } from "react/compiler-runtime";
import { FIELD_TO_LABEL_MAP } from "@/components/waves/memes/traits/schema";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import React from "react";
import { Tooltip } from "react-tooltip";
interface MemeDropTraitProps {
  readonly label: string;
  readonly value: string;
  readonly dropId?: string | undefined;
}
const convertValue = (value: string) => {
  if (value === "true") {
    return "Yes";
  }
  if (value === "false") {
    return "No";
  }
  if (!isNaN(Number(value))) {
    return formatNumberWithCommas(Number(value));
  }
  return value;
};
const MemeDropTrait: React.FC<MemeDropTraitProps> = t0 => {
  const $ = _c(17);
  const {
    label,
    value,
    dropId
  } = t0;
  const isMobile = useIsMobileDevice();
  let t1;
  if ($[0] !== value) {
    t1 = convertValue(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const convertedValue = t1;
  const tooltipId = dropId ? `meme-drop-trait-${dropId}-${label}` : `meme-drop-trait-${label}`;
  if (label === FIELD_TO_LABEL_MAP.pointsLoki) {
    console.log(value, typeof value);
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-block tw-text-[9px] tw-uppercase tw-tracking-wide tw-text-iron-500 tw-font-normal tw-mb-1">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== convertedValue || $[5] !== tooltipId) {
    t3 = <span className="tw-text-xs tw-text-iron-200 tw-font-medium tw-truncate" data-tooltip-id={tooltipId}>{convertedValue}</span>;
    $[4] = convertedValue;
    $[5] = tooltipId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== convertedValue || $[8] !== isMobile || $[9] !== tooltipId) {
    t4 = !isMobile && <Tooltip id={tooltipId} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{convertedValue}</span></Tooltip>;
    $[7] = convertedValue;
    $[8] = isMobile;
    $[9] = tooltipId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t5) {
    t6 = <div className="tw-bg-iron-900 tw-border tw-border-solid tw-border-iron-800 tw-rounded-lg tw-px-3 tw-py-1.5 tw-flex tw-flex-col">{t2}{t5}</div>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default MemeDropTrait;